import { List, Typography } from '@material-tailwind/react'
import { FiCheck } from 'react-icons/fi'
import PropTypes from 'prop-types'
import { monthOptions } from '../utils'

export const DisplayAttachmentHistory = ({ attachments }) => {
  if (attachments.length < 1) return <Typography variant='small' className='text-xs text-gray-400'>No hay archivos cargados</Typography>

  return (
    <List className='gap-2 p-0'>
      {
        attachments.map(({ id, documentInfo, updatedAtInWords, periodYear, periodMonth }) => (

          <div key={id} className='bg-gray-100 hover:bg-gray-200 py-2.5 rounded-lg px-3 text-xs grid grid-cols-11 grid-rows-2 cursor-pointer'>
            <section className='col-span-2 row-span-2 flex justify-between'>
              <div className='w-5 h-5 rounded-full bg-blue-100 text-blue-500 flex items-center justify-center'>
                <FiCheck size='1rem' />
              </div>
            </section>

            <div className='row-span-2 col-span-8'>
              <Typography className='text-xs row-span-1 col-span-8' variant='small'>{documentInfo.filename}</Typography>

              <div className='col-span-11'>

                {
                  periodMonth &&
                  <Typography className='text-xs text-gray-400 inline' >
                    {monthOptions.find(monthOption => monthOption.value === periodMonth).label}
                  </Typography>
                }
                {periodYear && <Typography className='text-xs text-gray-400 inline' variant='small'> {periodYear}</Typography>}
              </div>
            </div>
            <Typography className='text-xs row-span-2 col-span-1' variant='small'>{updatedAtInWords}</Typography>

          </div>
        ))
      }
    </List>
  )
}

DisplayAttachmentHistory.propTypes = {
  attachments: PropTypes.array
}

DisplayAttachmentHistory.defaultProps = {
  attachments: []
}
